import axios from 'axios';
import _ from 'lodash';
import api from './api';
import vlog from '../../vlog';

_.extend(api, {
  muteUser(params) {
    vlog.info('api#muteUser');

    api.configure();
    axios.defaults.headers.common.Accept = 'application/json';

    const url = '/api/internal/reporter_mutes';

    return axios.post(url, { reporter_mute: params }, api.axiosFix);
  },

  // Mirrors the legacy "Unmute User" rails-ujs link (users#delete_mute destroys the
  // ReporterMute rows; the JSON Accept keeps it from redirecting).
  unmuteUser({ muted_user_id: mutedUserId, reporting_user_id: reportingUserId }) {
    vlog.info('api#unmuteUser');

    api.configure();
    axios.defaults.headers.common.Accept = 'application/json';

    const url = `/users/${reportingUserId}/delete_mute`;

    return axios.delete(url, { params: { muted_user_id: mutedUserId }, ...api.axiosFix });
  },
});
